import { useContext } from 'react'
import Nav from '../../../components/dashboard/Nav'
import Sidebar from '../../../components/dashboard/sidebar'
import { Context } from '../../../utils/store'
// import FullPageLoader from '../../Loader/FullPage'
import Toaster from '../Toaster'

const DashboardLayout: React.FC = ({children}) => {
    const {state}= useContext(Context);
    console.log(state);
    return(
        <div className="w-full h-screen max-h-screen min-h-screen bg-[#FAFAFA]">
            <Nav />
            {
        
               state?.Toasts&&  state?.Toasts.length>0 &&   <> <Toaster/></>
            }
            <div className="w-full h-full flex relative">
                <Sidebar/>
                {/* <FullPageLoader /> */}
                {children}
            </div>
        </div>
    )
}


export default DashboardLayout